import { Box, Button, Heading, Icon, Text, VStack } from "@chakra-ui/react";
import IconCover from "components/IconCover";
import useTranslate from "hooks/useTranslate";
import { FaTimes } from "react-icons/fa";

const FancyBearsEmptyMessage = () => {
  const translate = useTranslate();

  return (
    <Box bg="bright.400" py="12" px="12" w="full">
      <VStack gap="4">
        <IconCover>
          <Icon as={FaTimes} w="8" h="8" />
        </IconCover>

        <Box textAlign="center" maxWidth={52}>
          <Heading fontSize="xl" fontWeight="800">
            {translate("fancyBears:empty:title")}
          </Heading>

          <Text lineHeight="tall" mt="2">
            {translate("fancyBears:empty:description")}
          </Text>
        </Box>

        <a
          href="https://opensea.io/collection/fancybearsmetaverseofficial"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "block",
            width: "100%",
          }}
        >
          <Button as="span" colorScheme="secondary" w="full">
            {translate("fancyBears:empty:buy")}
          </Button>
        </a>
      </VStack>
    </Box>
  );
};

export default FancyBearsEmptyMessage;
